var _path, _path2, _rect, _path3, _path4, _path5, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFbLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.466 4.444H8.653a4.208 4.208 0 00-4.209 4.209v22.813a4.208 4.208 0 004.209 4.208h11.25l.02-11.16h-2.9a.684.684 0 01-.683-.681l-.014-3.597a.684.684 0 01.684-.687h2.894v-3.476c0-4.034 2.464-6.23 6.062-6.23h2.953c.377 0 .684.306.684.684v3.033a.684.684 0 01-.684.684l-1.812.001c-1.957 0-2.336.93-2.336 2.295v3.009h4.3c.41 0 .728.358.68.765l-.427 3.597a.684.684 0 01-.68.604H24.79l-.019 11.16h6.695a4.208 4.208 0 004.208-4.209V8.653a4.208 4.208 0 00-4.208-4.209z",
    fill: "url(#fb-link_svg__paint0_linear_6030_125167)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.466 4.444H8.653a4.208 4.208 0 00-4.209 4.209v22.813a4.208 4.208 0 004.209 4.208h11.25l.02-11.16h-2.9a.684.684 0 01-.683-.681l-.014-3.597a.684.684 0 01.684-.687h2.894v-3.476c0-4.034 2.464-6.23 6.062-6.23h2.953c.377 0 .684.306.684.684v3.033a.684.684 0 01-.684.684l-1.812.001c-1.957 0-2.336.93-2.336 2.295v3.009h4.3c.41 0 .728.358.68.765l-.427 3.597a.684.684 0 01-.68.604H24.79l-.019 11.16h6.695a4.208 4.208 0 004.208-4.209V8.653a4.208 4.208 0 00-4.208-4.209z",
    fill: "url(#fb-link_svg__paint1_linear_6030_125167)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2F54EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.161 33.271c-.32 0-.621.125-.848.352l-.87.87a2.061 2.061 0 01-1.468.609 2.078 2.078 0 01-1.467-3.543l.87-.871a1.201 1.201 0 00-.848-2.048c-.32 0-.622.125-.848.351l-.871.871a4.445 4.445 0 00-1.311 3.164c0 1.196.465 2.32 1.31 3.164a4.445 4.445 0 003.165 1.311 4.445 4.445 0 003.164-1.31l.87-.872a1.201 1.201 0 00-.848-2.048z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.127 33.875c.226.226.527.351.848.351.32 0 .621-.125.848-.351l4.053-4.053c.226-.226.351-.528.351-.848 0-.32-.125-.622-.351-.849a1.192 1.192 0 00-.849-.351c-.32 0-.621.125-.848.351l-4.053 4.053a1.201 1.201 0 000 1.697z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.191 25.81a4.445 4.445 0 00-3.164-1.311 4.445 4.445 0 00-3.164 1.31l-.87.871a1.201 1.201 0 00.848 2.049c.32 0 .621-.125.848-.352l.87-.87a2.062 2.062 0 011.468-.609 2.078 2.078 0 011.468 3.543l-.871.871a1.191 1.191 0 00-.352.848c0 .32.125.622.352.849.226.226.528.351.848.351.32 0 .622-.125.849-.351l.87-.871a4.48 4.48 0 000-6.328z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#fff",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb-link_svg__paint0_linear_6030_125167",
    x1: 36.297,
    y1: 4.731,
    x2: 4.737,
    y2: 36.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb-link_svg__paint1_linear_6030_125167",
    x1: 35.605,
    y1: 4.514,
    x2: 4.513,
    y2: 35.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#4867AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7295E1"
  })))));
}

export default __webpack_public_path__ + "./fonts/fb-link.9b77b05fff6acdf0814d647ef9604a11.svg";
export { SvgFbLink as ReactComponent };